import React, { FunctionComponent } from 'react';
import { Accordion, AccordionDetails, Typography, Grid, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Moment from 'moment';
import MaterialTable from '../../../../generic-components/material-table/MaterialTable.Component';
import { MaterialTableProps } from 'material-table';
import styles from '../../nurse-case-manager-summary/NurseCaseManagerSummary.Styles';
import ReferralNoteTcmEntity from '../../../../../entities/ReferralNoteTcm.Entity';

interface ITcmNotesResponseProps {
    notes: Array<ReferralNoteTcmEntity>;
}

export const TcmNotesResponse: FunctionComponent<ITcmNotesResponseProps> = (props: ITcmNotesResponseProps) => {
    const classes = styles();

    const notesTableProps: MaterialTableProps<ReferralNoteTcmEntity> = {
        columns: [
            { title: 'Nurse Summary', field: 'nurseSummary' },
            { title: 'Review Notes', field: 'reviewNotes' },
            { title: 'Other Comments', field: 'otherComments' },
            {
                title: 'Created Date',
                field: 'createdDate',
                render: (rowData) =>
                    rowData?.createdDate ? <span>{Moment(rowData.createdDate).format('MM/DD/YYYY')}</span> : <span />,
            },
        ],
        data: props.notes ?? [],
        options: {
            selection: false,
            paging: false,
            toolbar: false,
        },
    };

    return (
        <Accordion defaultExpanded={true} className={classes.paper} square>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon className={classes.paperHeaderIcon} />}
                aria-controls="tcm-notes-content"
                id="tcm-notes-accordion"
                className={classes.paperHeader}
            >
                <Typography variant="subtitle2" className={classes.paperTitle}>
                    Notes
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={12}>
                        <MaterialTable tableProps={notesTableProps} />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};
